import { useEffect } from "react";

export default function Landing() {
  const GOOGLE_CLIENT_ID = "339987226679-c9fn0plo28plccf5uh7ucoag2s053v4m.apps.googleusercontent.com";
  const REDIRECT_URI = "http://localhost:3000/client/library";
  const COGNITO_CLIENT_ID = "bo24stke7qeq3l76saqttte3j";

  const COGNITO_AUTH_URL = `https://eu-west-3cee3sfvyn.auth.eu-west-3.amazoncognito.com/oauth2/authorize?identity_provider=Google&redirect_uri=${REDIRECT_URI}&response_type=CODE&client_id=${COGNITO_CLIENT_ID}&scope=openid+profile+email`;

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    script.onload = () => {
      console.log("Google One Tap script loaded!");
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: handleOneTapResponse,
          auto_select: true,
          cancel_on_tap_outside: false,
          context: "signin"
        });

        window.google.accounts.id.prompt((notification) => {
          console.log("One Tap Debug:", notification);
        });
      } else {
        console.log("Google object is not available");
      }
    };


    return () => {
      if (script.parentNode) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const handleOneTapResponse = (response) => {
    if (response && response.credential) {
      console.log("One Tap attivato, reindirizzo a Cognito...");
      window.location.href = COGNITO_AUTH_URL;
    }
  };

  return (
    <div className="relative w-full">
      <div className="w-full text-7xl text-center font-semibold my-[40vh]">
        Welcome to Athena BETA
      </div>

      <div id="googleOneTap" className="absolute top-4 right-4" />
    </div>
  );
}
